import styled from 'styled-components';

const Button = styled.button`
  display: block;
  background: rgb(28,60,92);
  background: linear-gradient(180deg, rgba(28,60,92,1) 0%, rgba(22,26,37,1) 100%);
  background-repeat: no-repeat;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: 14px;
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
  border-radius: 3px;
  height: 40px;
  width: 100%;
  cursor: pointer;
`;

interface IOwnProps {
  text: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

type Props = IOwnProps;

function Overlay(props: Props) {
  return (
      <Button onClick={props.onClick}>{props.text}</Button>
  );
}

export default Overlay;